/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum GoUserGoFunktion {
    KeineFunktion = 'KeineFunktion',
    GoBeirat = 'GoBeirat'
  }

    export const GoUserGoFunktionTranslocoMap: Record<GoUserGoFunktion, string> = {
    [GoUserGoFunktion.KeineFunktion]: 'goUserGoFunktion.keineFunktion',
    [GoUserGoFunktion.GoBeirat]: 'goUserGoFunktion.goBeirat',
    };

    export const GoUserGoFunktionOptions = [
  { value: GoUserGoFunktion.KeineFunktion, labelKey: 'goUserGoFunktion.keineFunktion' },
  { value: GoUserGoFunktion.GoBeirat, labelKey: 'goUserGoFunktion.goBeirat' },
    ];

